import axios from "axios";
import React, { useEffect, useRef, useState } from "react";
import Swal from "sweetalert2";



export default function Category() {

  const headers = {
    token: localStorage.getItem("userToken"),
  };
  let [category,setcategory]=useState([]);

  
async function addCategory() {
  let name = document.getElementById("nameOfCategory").value;
  let description = document.getElementById("description").value;

  const data = {
      name: name,
      description: description,
  };

  if (
    !name ||
    !description

  ) {
    Swal.fire({
      icon: "warning",
      title: "you must enter all inputs ",
      confirmButtonText: "Ok",
    });
    return;
  }

  try {
    const response = await axios.post(
      "https://vehex-production.up.railway.app/category/createCategory",
      data,
      { headers }
    );

    if (response.data.message === "Category created successfully") {
      Swal.fire({
        icon: "success",
        title: "Category added successfully",
        confirmButtonText: "Ok",
      });
    }
    console.log(response.data);
    getCategory()
  } catch (error) {
    console.error(
      "Error:",
      error.response ? error.response.data : error.message
    );
    Swal.fire({
      icon: "error",
      title: "error",
      text: "Please, try again!",
      confirmButtonText: "ok",
    });
  }
}

async function getCategory() {
  try {
    let res = await axios.get("https://vehex-production.up.railway.app/category");
    setcategory(res.data.categories)
    console.log(res)
  } catch (error) {
    console.error(
      error.response ? error.response.data : error.message
    );
  }
}

async function deleteCategory(id) {
  Swal.fire({
    title: "Are you sure?",
    text: "You won't be able to revert this!",
    icon: "warning",
    showCancelButton: true,
    confirmButtonColor: "#d33",
    cancelButtonColor: "#3085d6",
    confirmButtonText: "Yes, delete it!",
    cancelButtonText: "Cancel",
  }).then(async (result) => {
    if (result.isConfirmed) {
      try {
        let response = await axios.delete(
          `https://vehex-production.up.railway.app/category/deleteCategory/${id}`,
          { headers }
        );

        if (response.data.message === "Category and its products deleted successfully.") {
          Swal.fire({
            title: "The Category has been deleted.",
            icon: "success",
            confirmButtonColor: "#3085d6",
          });
          getCategory();

        }
      } catch (error) {
        console.error("Error deleting Category:", error);
        Swal.fire({
          title: "Error!",
          text: "There was an issue deleting the Category.",
          icon: "error",
          confirmButtonColor: "#d33",
        });
      }
    }
  });
}
let[catid,setCatid]=useState(null)
function setFormForUpdate(catId) {
  setCatid(catId)
  window.scrollTo({
    top: 0,    
    behavior: "smooth", 
  });
  const selectedCategory = category.find((cat) => cat._id === catId);
  if (selectedCategory) {
    document.getElementById("CategoryForm").classList.replace("d-block", "d-none");
    document.getElementById("CategoryFormUpdate").classList.replace("d-none", "d-block");

      document.getElementById("name").value = selectedCategory.name || "";
      document.getElementById("descriptionCat").value = selectedCategory.description || "";
   
  }
}
async function updaCategory(catid) {
  const name = document.getElementById("name")?.value;
  const decription = document.getElementById("descriptionCat")?.value;
 let data={
  name:name,
  description:decription
 }

  try {
    const response = await axios.put(
      `https://vehex-production.up.railway.app/category/updateCategory/${catid}`,
      data,
      { headers }
    );
    console.log(response.data);
   

    if (response.data.message === "Category updated successfully") {
      Swal.fire({
        icon: "success",
        text: "Category updated successfully.",
        confirmButtonText: "OK",
      });
      document.getElementById("CategoryForm").classList.replace("d-none", "d-block");
      document.getElementById("CategoryFormUpdate").classList.replace("d-block", "d-none");
    

      getCategory(); 
    }
  } catch (error) {
    Swal.fire({
      icon: "error",
      text: "Error updating Category",
      confirmButtonText: "OK",
    });
  }
}





useEffect(() => {
  getCategory();
}, []); 
  return (
    <>
      <form className="ProductForm overflow-x-auto mb-5 d-block" id="CategoryForm" onSubmit={(e) => {
          e.preventDefault();
         
        }} >
        <h1 className="heading">  Add Category</h1>
        <div className="d-grid">
          <div>
            <label
              htmlFor="nameOfCategory"
              className="mb-1 fs-5 fw-500 main-color"
            >
              Name
            </label>
            <input
              type="text"
              name="nameOfCategory"
              id="nameOfCategory"
              className="form-control fs-5 mb-2"
            />

            
          </div>
          {/* ========================================== */}

          <div>
            <label
                htmlFor="description"
                className="mb-1 fs-5 fw-500 main-color"
              >
                Description
              </label>
              <input
                type="text"
                name="description"
                id="description"
                className="form-control fs-5 mb-2"
              />

            
              </div>
            </div>
        <button
          type="submit"
          onClick={()=>addCategory()}
         
          className=" fs-5 mt-2 fw-500 "
        >
         
          Add Category
     
        </button>
      </form>

      <form className="ProductForm overflow-x-auto mb-5 d-none" id="CategoryFormUpdate"  onSubmit={(e) => {
          e.preventDefault();
         
        }} >
        <h1 className="heading">  Update Category</h1>
        <div className="d-grid">
          <div>
            <label
              htmlFor="nameOfCategory"
              className="mb-1 fs-5 fw-500 main-color"
            >
              Name
            </label>
            <input
              type="text"
              name="nameOfCategory"
              id="name"
              className="form-control fs-5 mb-2"
            />

            
          </div>
          {/* ========================================== */}

          <div>
            <label
                htmlFor="description"
                className="mb-1 fs-5 fw-500 main-color"
              >
                Description
              </label>
              <input
                type="text"
                name="description"
                id="descriptionCat"
                className="form-control fs-5 mb-2"
              />

            
              </div>
            </div>
        <button
          type="submit"
          onClick={()=>updaCategory(catid)}
         
          className=" fs-5 mt-2 fw-500 "
        >
         
          Update Category
     
        </button>
      </form>

      <div className=" overflow-x-auto">
        {category?.length>0?<>        <table className=" table table-striped">
          <thead>
            <tr>
              <th>Name</th>
              <th>Description</th>
              <th>Update</th>
              <th>Delete</th>
            </tr>
          </thead>
          <tbody>
            {category?.map((cat) => (
          <tr key={cat._id}>
            <td>{cat?.name || "______"}</td>
            <td>{cat?.description || "______"}</td>
            <td>
              <button
                className="btn btn-success"
                onClick={() => setFormForUpdate(cat._id)}
              >
                Update
              </button>
            </td>
            <td>
              <button
                className="btn btn-danger"
                onClick={() => deleteCategory(cat._id)}
              >
                Delete
              </button>
            </td>
          </tr>
        ))}
          </tbody>
        </table></>:<div className="main-color fs-5 fw-500 text-center">No Category Found </div>}

      </div>
    </>
  );
}
